import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight } = FiIcons;

function Newsletter() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const submit = (event) => {
    event.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setMessage('Please enter a valid email address.');
      return;
    }
    setMessage('Subscription storage is not connected yet.');
  };

  return (
    <section className="newsletter" id="newsletter">
      <div>
        <span className="eyebrow light">THE DAILY BRIEFING</span>
        <h2>Get the news that matters.</h2>
        <p>Receive the latest headlines, essential stories and considered perspectives every morning.</p>
      </div>
      <form onSubmit={submit} noValidate>
        <label htmlFor="newsletter-email">Email address</label>
        <div className="field-row">
          <input
            id="newsletter-email"
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
          <button type="submit">Subscribe <SafeIcon icon={FiArrowRight} /></button>
        </div>
        {message && <p className="form-message">{message}</p>}
        <small>By subscribing, you agree to our privacy policy.</small>
      </form>
      <div data-greta-form-placeholder="NEWSLETTER_SIGNUP">This form is not collecting yet.</div>
    </section>
  );
}

export default Newsletter;